import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { AlloyButton, SystemFeedback } from 'cat-ecommerce-alloy';

const VideoWarning = ({ className = '' }) => {
  const [t] = useTranslation();

  return (
    <div
      className={cx('t-0 position-absolute', className)}
      data-testid="cookie-warning-message"
    >
      <SystemFeedback type="warning">
        <div className={cx('fw-bold text-sans-serif text-sm')}>
          {t('COOKIES_REQUIRED')}
        </div>
        <div className={cx('fw-normal text-sans-serif mt-1 text-sm')}>
          {t('COOKIES_WATCH_VIDEOS_ACCEPT')}
        </div>
        <div>
          <AlloyButton
            buttonType="ghost"
            className={cx('ot-sdk-show-settings p-0 mb-2 mt-2 text-md')}
          >
            {t('COOKIE_SETTINGS')}
          </AlloyButton>
        </div>
      </SystemFeedback>
    </div>
  );
};

export default VideoWarning;
